<template>
  <span class="tw-daisy-loading tw-daisy-loading-spinner"></span>
</template>
